import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import {
  buildingCommonFields,
  buildingRevisionFields,
} from './common/buildingCommonFields';
import { coordinateFields } from './common/coordinateFields';
import { msg } from '@lingui/core/macro';
import { volumeUnitField } from './common/sharedFields';
import { utilityCostFields } from './common/utilityCostFields';

export const waterRecyclingMetadata = {
  displayName: msg({
    message: 'Water recycling',
    context: 'Activity data schema name for water recycling',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...buildingCommonFields,
    ...coordinateFields,
    ...buildingRevisionFields,
    ...utilityCostFields,
    quantity: {
      displayName: msg({
        message: 'Water recycled',
        context: 'The quantity of water recycled.',
      }),
      externalDescription: msg({
        message:
          'The quantity of water used more than once before discharge through recycle or reuse.',
        context: 'Water recycled',
      }),
    },
    unit: volumeUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
